import routes from './../routes';

export const fetchConfigVars = () => {
  return fetch(routes.config.vars, {
    method: 'GET',
    headers: {
      "Accept": "application/json"
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error("Error fetching config vars");
  });
};
